import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-customer-params',
  templateUrl: './customer-params.component.html',
  styleUrls: ['./customer-params.component.css']
})
export class CustomerParamsComponent implements OnInit {

  form: any | FormGroup
  paramData:any = []
  cid:any

  isLoading: any = false
  deleteId: any
  editForm: any | FormGroup
  customerParamData: any

  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }

  searchKey: any = ""
  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;
  first: number = 0;

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    let href:any = window.location.href;
    let messages = href.split('/') 
    let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
    this.actionControls = action

    this.cid = sessionStorage.getItem('cid')
    // this.getCustomerParams()

    this.getAllCustomerParamWithPagination(this.pageNumber,this.recordsPerPage)
    this.form = this.fb.group({
      name: [''],
    })  

    this.editForm = this.fb.group({
      name: [''],
    })  
  }

  onTableDataChange(event: any) {
    console.log(event)

    this.pageNumber = event.page;

    if(this.searchKey != ""){
      this.getCustomerParamByWildSearch(this.pageNumber,this.recordsPerPage)
    }else{
      this.getAllCustomerParamWithPagination(this.pageNumber,this.recordsPerPage)
    }
  }

  getCustomerParamsById(id:any){
    this.generic_service.getCustomerParamsById(id).subscribe(
      (response:any)=>{
        console.log(response)
        this.editForm.patchValue({
          name: response.response.name,
        })
        this.customerParamData = response.response
        console.log(this.editForm.value)
      },
      (error)=>{
        console.log(error)
      }
    )
  }

  addCustomerParam(){

      let body = {
        "name": String(this.form.get('name').value),
        "cid": this.cid
      }

    console.log(body)
    this.generic_service.addCustomerParam(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getAllCustomerParamWithPagination(this.pageNumber,this.recordsPerPage)
        this.toastr.success(response.message);
        this.cancelModel()
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      },
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
    document.getElementById("closeModalButton2")?.click()
  }

  // getCustomerParams(){
  //   this.isLoading = true

  //   this.generic_service.getCustomerParams().subscribe(
  //     (res:any)=> {
  //       console.log(res)
  //       this.paramData = res.response
  //       this.totalRecords = res.response.length
  //       this.isLoading = false
  //     },
  //     (err:any)=>{
  //       console.log(err)
  //     }
  //   )
  // }

  deleteCustomerParam(){
    this.generic_service.deleteCustomerParam(this.deleteId).subscribe(
      (res:any)=>{
        this.toastr.success("Successfully Deleted");
        this.getAllCustomerParamWithPagination(this.pageNumber,this.recordsPerPage)
        this.cancelModel();
      },err=>{
        this.toastr.error(err.errors[0].description)
      }
    )
  }

  del(id:any){
    this.deleteId = id
  }

  updateCustomerParams(){

    let body = {
      "id": this.customerParamData.id,
      "customerParamId": this.customerParamData.customerParamId,
      "name": String(this.editForm.get('name').value),
      "version": 0,
      "isActive": true,
      "description": "",
      "cid": this.cid
    }

  console.log(body)
  this.generic_service.updateCustomerParams(body).subscribe(
    (response:any)=>{
      console.log(response)
      this.getAllCustomerParamWithPagination(this.pageNumber,this.recordsPerPage)
      this.toastr.success("Successfully Updated");
      this.cancelModel()
    },
    (err:any)=>{
      console.log(err)
      this.toastr.error(err.error.errors[0].description);
    },
  )
}


getAllCustomerParamWithPagination(pageNumber: any,recordsPerPage: any){
  this.isLoading = true

  this.generic_service.getAllCustomerParamWithPagination(pageNumber,recordsPerPage).subscribe(
    (response:any)=>{
      console.log(response)
      this.paramData = response.response.customerParamList;
      this.totalRecords = response.response.totalRecords;
      this.isLoading = false

    }
  )
}


getCustomerParamByWildSearch(pageNumber: any,recordsPerPage: any){
  if(this.searchKey != ""){
    this.isLoading = true

    this.generic_service.getCustomerParamByWildSearch(this.searchKey,pageNumber,recordsPerPage).subscribe(
      (response:any)=>{
        console.log(response);
        this.paramData = response.response.customerParamList;
        this.totalRecords = response.response.totalRecords;
        this.isLoading = false

      },
      (err:any)=>{
        console.log(err)
      }
    )
  }else{
    this.getAllCustomerParamWithPagination(this.pageNumber,this.recordsPerPage)
  }
}

refreshSearch(){
  this.searchKey = ""
  this.getCustomerParamByWildSearch(this.pageNumber,this.recordsPerPage)
}


}
